var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_881_14234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6288 17.6738H16.7033L21.6994 11.6104H18.7368L25.2673 0H15.8432L10.5922 14.6699H15.2804L14.1813 17.6794H8.08087C7.57648 17.6794 7.08801 17.746 6.61548 17.8626L10.486 11.616H7.52338L11.6806 0H2.25648L0 14.6699H4.68818L3.94486 19.2785C2.57505 20.5001 1.70962 22.3158 1.70962 24.3425C1.70962 28.0238 4.56075 31.0055 8.08087 31.0055H19.6288C23.1489 31.0055 26 28.0238 26 24.3425C26 20.6611 23.1489 17.6794 19.6288 17.6794V17.6738Z",
    fill: "#59B3C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5417 23.7872L11.7188 23.0876C12.4674 22.1214 13.3009 21.6328 14.1929 21.6328C14.2035 21.6328 14.2142 21.6328 14.2301 21.6328C15.7114 21.655 16.7414 23.0376 16.7839 23.0987L15.9397 23.7761C15.9397 23.7761 15.1698 22.7544 14.2088 22.7433H14.1929C13.6301 22.7433 13.078 23.0931 12.5417 23.7872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2253 23.787L18.4023 23.0873C19.151 22.1212 19.9845 21.6326 20.8765 21.6326C20.8871 21.6326 20.8977 21.6326 20.9137 21.6326C22.395 21.6548 23.425 23.0374 23.4675 23.0984L22.6233 23.7759C22.6233 23.7759 21.8534 22.7542 20.8924 22.7431H20.8765C20.3137 22.7431 19.7615 23.0929 19.2253 23.787Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_881_14234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.1763b8d2a1591256094546e4abf93e8e.svg";
export { ForwardRef as ReactComponent };